import React from 'react';
import { string, number, bool, arrayOf, shape } from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import getSubCategoryUrl from '../../../utils/url';

import './style.scss';

const source = 'hplo_subcat_first_step';

const SubCategory = ({ name, categorySlug, subCategorySlug, picture, image, isTouch, pos }) => (
    <I18nProvider>
        {({ i18n }) => {
            const subCategoryName = i18n.t(`logged_out_homepage.subcategory_carousel.${name}.sub`);

            return (
                <a href={getSubCategoryUrl(categorySlug, subCategorySlug, {source, pos})} className="subcategory">
                    <h4>
                        <small><I18n k={`logged_out_homepage.subcategory_carousel.${name}.main`}/></small>
                        {subCategoryName}
                    </h4>
                    {isTouch ?
                        <img alt={subCategoryName} src={image.src} srcSet={image.srcSet}/> :
                        <picture>
                            {
                                picture.map((img, index) => (
                                    <source key={index} media={img.media} srcSet={img.srcSet}/>
                                ))
                            }
                            <img alt={subCategoryName} src={image.src}/>
                        </picture>
                    }
                </a>
            );
        }}
    </I18nProvider>
);

SubCategory.propTypes = {
    name: string,
    categorySlug: string,
    subCategorySlug: string,
    picture: arrayOf(
        shape({
            media: string,
            srcSet: string
        })
    ),
    image: shape({
        media: string,
        srcSet: string
    }),
    pos: number,
    isTouch: bool
};

export default SubCategory;
